module.exports = __webpack_public_path__ + "img/drop-right.08d5a682.svg";